/*
 * Shows a person's name in one consistent style: first letter of each word
 * capitalised, the rest lowercase ("TEO SHENG CHING" -> "Teo Sheng Ching").
 */
const formatName = (name) => {
  if (name === null || name === undefined) return "";

  return String(name)
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase()
    .replace(/(^|[\s\-'])(\p{L})/gu, (match, separator, letter) =>
      separator + letter.toUpperCase()
    );
};

export default formatName;
